module.exports = __webpack_public_path__ + "img/00025.9ea494a2.webp";